// src/components/organization/InviteUser.jsx
// ✅ Non usa useOrganization — riceve dati come props da TeamManagement
import React, { useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import { XMarkIcon } from '@heroicons/react/24/outline';

const ROLES = [
  { value: 'VIEWER',           label: 'Visualizzatore', description: 'Può solo visualizzare' },
  { value: 'FIELD_SUPERVISOR', label: 'Supervisore',    description: 'Visualizza e aggiorna stato' },
  { value: 'ENGINEER',         label: 'Ingegnere',      description: 'Gestione progetti e spese' },
  { value: 'ACCOUNTANT',       label: 'Contabile',      description: 'Gestione spese e budget' },
  { value: 'SITE_MANAGER',     label: 'Capo Cantiere',  description: 'Gestione completa cantiere' },
  { value: 'SUPER_ADMIN',      label: 'Super Admin',    description: 'Tutti i permessi' },
];

const InviteUser = ({ isOpen, onClose, onSuccess, onInvite }) => {
  // ✅ Legge planLimits e usage dal context globale — zero fetch extra
  const { planLimits, usage } = useAuth();

  const [email, setEmail] = useState('');
  const [role, setRole] = useState('VIEWER');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    // onInvite viene da TeamManagement che usa useOrganization.inviteUser
    const result = await onInvite(email, role);
    setLoading(false);

    if (result.success) {
      setEmail('');
      setRole('VIEWER');
      onSuccess?.();
      onClose();
    } else {
      setError(result.error || 'Errore durante l\'invio');
    }
  };

  if (!isOpen) return null;

  const maxUsers = planLimits?.maxUsers;
  const usedUsers = usage?.usersCount || 0;
  const isUnlimited = !maxUsers || maxUsers >= 999999;
  const remainingSlots = isUnlimited ? '∞' : maxUsers - usedUsers;

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      <div className="flex items-center justify-center min-h-screen px-4 pt-4 pb-20 text-center sm:block sm:p-0">
        <div
          className="fixed inset-0 transition-opacity bg-gray-500 bg-opacity-75"
          onClick={onClose}
        />

        <div className="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full relative z-10">
          <div className="bg-white px-4 pt-5 pb-4 sm:p-6">
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-lg font-medium text-gray-900">Invita un nuovo membro</h3>
              <button onClick={onClose} className="text-gray-400 hover:text-gray-500">
                <XMarkIcon className="h-6 w-6" />
              </button>
            </div>

            <form onSubmit={handleSubmit} className="space-y-4">
              {error && (
                <div className="bg-red-50 border border-red-200 rounded-lg p-3 text-sm text-red-600">
                  {error}
                </div>
              )}

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Email *
                </label>
                <input
                  type="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  placeholder="collega@azienda.com"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Ruolo *
                </label>
                <select
                  value={role}
                  onChange={(e) => setRole(e.target.value)}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                >
                  {ROLES.map((r) => (
                    <option key={r.value} value={r.value}>
                      {r.label} — {r.description}
                    </option>
                  ))}
                </select>
              </div>

              <div className="bg-gray-50 rounded-lg p-3 text-sm">
                <p className="text-gray-600">
                  L'invitato riceverà una email con un link per completare la registrazione.
                </p>
                <p className="text-gray-500 text-xs mt-1">
                  Posti rimanenti: {remainingSlots} {!isUnlimited && `/ ${maxUsers}`}
                </p>
              </div>

              <div className="flex justify-end gap-3 pt-2">
                <button
                  type="button"
                  onClick={onClose}
                  className="px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50"
                >
                  Annulla
                </button>
                <button
                  type="submit"
                  disabled={loading}
                  className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50"
                >
                  {loading ? 'Invio...' : 'Invia invito'}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InviteUser;